import { IConfiguredHttp } from './http';

enum ContentFormats {
	QUALITY_GPT = 'quality-gpt',
}

interface IQualityGptFormat {
	availability: Array<{ start_on: string, end_on: string }>;
	images: Array<{
		caption: string | null;
		created_at: string;
		updated_at: string;
		resolution: `${number}x${number}`;
	}>;
	reviews: unknown[];
	pricing: Array<{
		start_date: string;
		end_date: string;
		smart_price: boolean;
		currency: string;
		duration: number;
		value: number;
		discounts: Array<{
			factor: number;
			nights: number;
		}>;
		how_many_weekdays_checkin_allowed_on: number;
		min_stay: number;
		max_stay: number;
		price_per_night: number;
	}>;
	property: {
		property_details: {
			entrance_floor: number;
			number_of_floors: number;
			capacity: number;
			latitude: number;
			longitude: number;
		};
		checkin_checkout_deposits: {
			check_in: `${number}:${number}`;
			check_out: `${number}:${number}`;
			security_deposit: string;
		};
		restrictions: Array<{
			restriction_type: string;
			allowed: boolean
		}>;
		amenities_list: string[];
		bedroom_bed_type_counts: {
			[key: string | number]: {
				[bedType: string]: number;
			}
		};
		bathroom_details: {
			[key: number]: {
				ensuite: string;
				bath_type: string;
				shower: string;
				toilet: string
			}
		}
	};
}
export interface IAvailableDaysFormat {
	id: string;
	availableNights: number;
	valid: boolean;
	blockedDays: number;
}
export interface IAirbnbHostAccount {
	id: number;
	user_id: string;
	account_email: string;
	linked: boolean;
	host_group: string | null;
	currency: string | null;
}

export interface IClientApi {
	getGptContent: (propertyId: string | number) => Promise<IQualityGptFormat>;
	getAvailabilityValidity: (propertyId: string | number | undefined) => Promise<IAvailableDaysFormat>;
	getAirbnbHostAccountByCustomerId: (customerId: string | undefined) => Promise<IAirbnbHostAccount>;
}

const clientApiFactory = (http: IConfiguredHttp, prefix = ''): IClientApi => ({
	getGptContent(propertyId) {
		return http.get(`${prefix}/content/${propertyId}/format/${ContentFormats.QUALITY_GPT}`);
	},
	getAvailabilityValidity(propertyId) {
		return http.get(`${prefix}/availability/property/${propertyId}/valid`);
	},
	getAirbnbHostAccountByCustomerId(customerId) {
		return http.get(`${prefix}/admin/airbnb/host-account/customer/` + customerId);
	},
});

export default clientApiFactory;
